(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class CustomerReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      if (!this.rail || this.rail.children.length === 0) return;

      const speed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplay = setInterval(() => this.#advance(), speed);

      this.addEventListener('pointerenter', () => this.#stop());
      this.addEventListener('pointerleave', () => this.#start(speed));
      this.addEventListener('focusin', () => this.#stop());
      this.addEventListener('focusout', () => this.#start(speed));
    }

    disconnectedCallback() { this.#stop(); }

    #step() {
      const card = this.rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.rail).gap) || 14;
      return card.offsetWidth + gap;
    }

    #advance() {
      const atEnd = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 4;
      if (atEnd) {
        this.rail.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.rail.scrollBy({ left: this.#step(), behavior: 'smooth' });
      }
    }

    #start(speed) {
      this.#stop();
      this.autoplay = setInterval(() => this.#advance(), speed);
    }

    #stop() {
      if (this.autoplay) { clearInterval(this.autoplay); this.autoplay = null; }
    }
  }

  customElements.define('customer-reviews-carousel', CustomerReviewsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
